module.exports = __webpack_public_path__ + "static/img/01.93fe3d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/01.jpg
// module id = 350
// module chunks = 1